// Public-facing brand name (user-visible)
export const PUBLIC_APP_NAME = 'Doctogenic';

// Internal codename (keep out of UI/SEO). Use only in dev logs if ever needed.
export const INTERNAL_CODE_NAME = 'Katara';
